import type { IAM_APIPermission, IAM_Permission } from '../../common/reducers/types/IAMReducer.types'

interface I_ResourceMapNode {
  [permissions: string]: IAM_Permission[]
}

interface I_ServiceMapNode {
  [resource: string]: I_ResourceMapNode
}

interface I_ResourceNode {
  name: string,
  children: I_LeafPermission[]
}

export interface I_ServiceNode {
  name: string,
  children: I_ResourceNode[]
}

export interface I_LeafPermission extends IAM_Permission {
  is_leaf: boolean
}

const buildPermissionsTree: (permissions: IAM_APIPermission[]) => I_ServiceNode[] = (permissions) => {
  const serviceMap: I_ServiceMapNode = {}
  if (!Array.isArray(permissions)) {
    return []
  }

  for (const permission of permissions) {
    if (!permission) {
      continue
    }
    const [service, resource] = permission.name.split('.')
    if (!serviceMap.hasOwnProperty(service)) {
      serviceMap[service] = {}
    }
    const _service = serviceMap[service]

    const resourceKey = `${service}.${resource}`
    if (!_service.hasOwnProperty(resourceKey)) {
      _service[resourceKey] = []
    }
    const _resource = _service[resourceKey]

    _resource.push(permission)
  }

  return Object.entries(serviceMap).reduce((array: I_ServiceNode[], [service, iResource]) => {
    const node: I_ServiceNode = { name: service, children: [] }
    for (const [resource, permissions] of Object.entries(iResource)) {
      const _permissions = permissions.map(permission => ({ ...permission, is_leaf: true }))
      const resObject: I_ResourceNode = { name: resource, children: _permissions }
      node.children.push(resObject)
    }
    array.push(node)
    return array
  }, [])
}

export default buildPermissionsTree
